export default {
      id: "twitter-usage",
      viewBox: "0 0 18 14",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }